import type { CNSProjectNextStep, CNSProjectNextStepKind } from "@/models/cns";

const ACTION_TOOL_FOCUS: Readonly<Record<string, string>> = {
  question_answer: "clarifying-questions",
  assumption_selection: "assumption-selection",
  hypothesis_selection: "hypothesis-selection",
  experiment_card_selection: "experiment-card-selection",
  sources: "sources",
  assign_experiment: "assign_experiment",
  approve_experiment: "approve_experiment",
  setup_tracker: "setup_tracker",
  lock_tracker: "lock_tracker",
  mark_complete: "mark_complete",
  insights_draft: "insights_draft",
  learning_gate: "learning_gate",
  learning_qa: "learning_qa",
  learning_card: "learning_card",
  connect_source: "connect_source",
};

const NEXT_STEP_ACTION_TYPE: Partial<Record<CNSProjectNextStepKind, string>> = {
  HYPOTHESIS_NEEDS_EXPERIMENT: "experiment_card_selection",
  EXPERIMENT_REVIEW: "approve_experiment",
  EXPERIMENT_ASSIGN: "assign_experiment",
};

export function focusToolFromActionType(actionType: string | null | undefined): string | null {
  if (!actionType) return null;
  return ACTION_TOOL_FOCUS[actionType] ?? actionType;
}

/** Resolves optional card focus for navigation from a project-home next-step row. */
export function focusToolFromNextStep(step: CNSProjectNextStep): string | null {
  return focusToolFromActionType(step.actionType ?? NEXT_STEP_ACTION_TYPE[step.kind]);
}
